/* 积分订单组件 */
<template>
  <div>
    <div class="section-header color-product-bg">
      <div>订单编号：{{ value.code }}</div>
      <div class="right color-sub-title">{{ value.createTime | date }}</div>
    </div>
    <div class="product-row">
      <div class="product-info flex">
        <div class="cover-wrapper color-product-bg">
          <div class="cover" :style="styleBackgroundImage(coverFileKey)"></div>
        </div>
        <div>
          <b>{{ product.name }}</b>
          <p class="comment color-sub-title">{{ product.subTitle }}</p>
          <p>x {{ product.qtr }}</p>
        </div>
      </div>
      <div class="price center">
        <div v-if="!isStatusCancel">
          {{ realPay.egg }} + ￥{{ realPay.money | moneyFormat }}
        </div>
        <div v-else>
          {{ value.totalPrice | egg }} (￥{{ value.totalPrice | moneyFormat }})
        </div>
      </div>
      <div class="status center">{{ getStatusText(value.status) }}</div>
      <div class="center">
        <a
          :href="'https://b.zhulogic.com/mall/me/orders/' + value.id"
          target="_blank"
        >
          <button class="sml-btn">查看详情</button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { styleBackgroundImage } from "@/utils";
import { ORDER_STATUS } from "@/constants";
import { RealPay } from "@/utils/egg";

export default {
  props: {
    value: Object,
  },

  computed: {
    balance() {
      return this.$store.state.balance;
    },

    product() {
      if (!this.value || !this.value.products) return {};
      const [product] = this.value.products;
      return product || {};
    },

    coverFileKey() {
      return (this.product.coverFile && this.product.coverFile.key) || "";
    },

    realPay() {
      return new RealPay(this.value.paidEgg, this.value.paidPrice);
    },

    isStatusCancel() {
      return this.value.status === ORDER_STATUS.CANCEL;
    },
  },

  methods: {
    styleBackgroundImage,
    getStatusText(status) {
      switch (status) {
        case 1:
          return "待付款";
          break;
        case 2:
          return "待发货";
          break;
        case 3:
          return "待收货";
          break;
        case 4:
          return "待评价";
          break;
        case 5:
          return "合同已确认";
          break;
        case 6:
          return "已取消";
          break;
        case 7:
          return "已关闭";
          break;
        default:
          return "查询不到状态";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.product-info {
  width: 46%;
  padding: 0;

  &.flex {
    display: flex;
    align-items: center;
  }
}

.price,
.status,
.option {
  width: 20%;
}

.product-row {
  display: flex;
  margin-bottom: 30px;
  align-items: center;
}

.cover-wrapper {
  margin-right: 20px;
}

.cover {
  width: 120px;
  height: 120px;
  background: no-repeat center;
  background-size: auto 85%;
  // background-image: url(../../../assets/placeholder/product-cover.png);
  background-image: url("");
}

.icon-trash {
  cursor: pointer;
  margin-left: 30px;
}

.icon-trash:hover {
  color: #f43f3f;
}

.no-has-trash {
  margin-right: 48px;
}
.section-header {
  height: 40px;
  padding: 0 30px;
  margin-top: 20px;
  margin-bottom: 30px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.color-product-bg {
  background: rgba(238, 238, 238, 1);
}
.section-header .right {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: right;
  margin-bottom: 0px;
}
.no-has-trash {
  margin-right: 48px;
}
.color-sub-title {
  color: #6c6f70;
}

.sml-btn {
  width: 80px;
  height: 28px;
  line-height: 28px;
  border-radius: 0px;
  font-size: 12px;
  color: #fff;
  border: none;
  background: #e56a69;
  span {
    color: #fff;
    font-size: 12px;
  }
  cursor: pointer;
  a {
    cursor: pointer;
    color: #313131;
  }
}
</style>
